import axios from '@axios'

export default {
  namespaced: true,
  state: {
    grupos: [],
  },
  getters: {
    getUGrupos: state => state.grupos,
  },
  mutations: {
    SET_GRUPOS(state, grupos) {
        state.grupos = grupos
    },
  },
  actions: {
    fetchUGrupos(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('/groups', { params: queryParams })
          .then(response => {
            ctx.commit('SET_GRUPOS', response.data.grupos)
            resolve(response)
          })
          .catch(error => reject(error))
      })
    },
    fetchGrups(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('/groups', { params: queryParams })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchGrupo(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/groups/${id}`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    addGrupoUsuario(ctx, grupoUsuarioData) {
      return new Promise((resolve, reject) => {
        axios
          .post('/groups', grupoUsuarioData)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    updatedGrupoUsuario(ctx, grupoUsuarioData) {
      return new Promise((resolve, reject) => {
        axios
          .put(`/groups/${grupoUsuarioData.id}`, {
            ...grupoUsuarioData,
          })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
  },
}
